import { Routes, Route, Navigate, useParams } from "react-router-dom";
import { techniciannavigationLinks } from "../data/navData";
import DashboardLayout from "../layout/DashboardLayout/DashboardLayout";
import TechnicianHome from "../pages/technicianpages/TechnicianHome";
import TechnicianWorkOrder from "../pages/technicianpages/TechnicianWorkOrder";
import TechnicianMSchedule from "../pages/technicianpages/TechnicianMSchedule";
import TechnicianAttendance from "../pages/technicianpages/TechnicianAttendance";
import AttendanceRecords from "../pages/technicianpages/AttendanceRecords";
import LeaveRecords from "../pages/technicianpages/LeaveRecords";
import ApplyLeave from "../pages/technicianpages/ApplyLeave";
import OvertimeContent from "../pages/technicianpages/OvertimeTechnician";
import OvertimeRecords from "../pages/technicianpages/OvertimeRecords";
import ApplyOvertime from "../pages/technicianpages/ApplyOvertime";
import ReapplyOvertime from "../pages/technicianpages/ReapplyOvertime";
import OvertimeMonthlyLimit from "../pages/technicianpages/OvertimeMonthlyLimit";
import Calendar from "../components/Calendar/Calendar";
import CalendarOverview from "../components/Calendar/CalendarOverview";
import Account from "../components/Account/Account";
import ProtectedRoute from "./ProtectedRoute";
import AttendanceRecordDetail from "../pages/attendance/AttendanceRecordDetail";

const AttendanceRecordRedirect = () => {
  const { id } = useParams();
  if (!id) {
    return <Navigate to="/technician/attendance/record" replace />;
  }
  return (
    <Navigate
      to={`/technician/attendance/record/${encodeURIComponent(id)}`}
      replace
    />
  );
};

const TechnicianRoutes = () => {
  return (
    <DashboardLayout
      navigationLinks={techniciannavigationLinks}
      roleBasePath="technician"
      useApiLogout={false}
    >
      <Routes>
        <Route
          path="overtime/records"
          element={
            <ProtectedRoute
              element={<OvertimeRecords />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="overtime/apply"
          element={
            <ProtectedRoute
              element={<ApplyOvertime />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="overtime/reapply"
          element={
            <ProtectedRoute
              element={<ReapplyOvertime />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="overtime/monthly-limit"
          element={
            <ProtectedRoute
              element={<OvertimeMonthlyLimit />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance"
          element={
            <ProtectedRoute
              element={<TechnicianAttendance />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance/record"
          element={
            <ProtectedRoute
              element={<AttendanceRecords />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance/record/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordRedirect />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance/record/:id"
          element={
            <ProtectedRoute
              element={<AttendanceRecordDetail />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance/leave-records"
          element={
            <ProtectedRoute
              element={<LeaveRecords />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="attendance/apply-leave"
          element={
            <ProtectedRoute
              element={<ApplyLeave />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path=""
          element={
            <ProtectedRoute
              element={<TechnicianHome />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="work-order"
          element={
            <ProtectedRoute
              element={<TechnicianWorkOrder />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="maintenance-schedule"
          element={
            <ProtectedRoute
              element={<TechnicianMSchedule />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="overtime"
          element={
            <ProtectedRoute
              element={<OvertimeContent />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="calendar"
          element={
            <ProtectedRoute
              element={<CalendarOverview />}
              requiredRole="Technician"
            />
          }
        />
        <Route
          path="calendar/:year"
          element={
            <ProtectedRoute element={<Calendar />} requiredRole="Technician" />
          }
        />
        <Route
          path="account"
          element={
            <ProtectedRoute element={<Account />} requiredRole="Technician" />
          }
        />
        <Route path="*" element={<h1>404 - Page Not Found</h1>} />
      </Routes>
    </DashboardLayout>
  );
};

export default TechnicianRoutes;
